interface Config {
  version: string;
  environment: 'production' | 'demo' | 'staging' | 'development';
  baseUrl: string;
  apiUrl: string;
  bffUrl: string;
  keycloak: {
    url: string;
    realm: string;
    clientId: string;
    enableLogging?: boolean;
    silentCheckSsoRedirectUri: string;
  };
  superset: {
    baseUrl: string;
  };
  heap: {
    enabled: boolean;
    appId: string;
  };
  sentry: {
    enabled: boolean;
    dsn: string;
  };
  unleash: {
    enabled: boolean;
    url: string;
    clientKey: string;
    appName: string;
    refreshInterval: number;
  };
  clarity: {
    projectId?: string;
  };
  piniaStoreKeyPrefix: string;
}
export const config: Config = {
  version: 'demo',
  environment: 'demo',
  baseUrl: '/',
  apiUrl: '',
  bffUrl: '',
  keycloak: {
    url: '',
    realm: '',
    clientId: '',
    enableLogging: false,
    silentCheckSsoRedirectUri: '',
  },
  superset: {
    baseUrl: '',
  },
  heap: {
    enabled: false,
    appId: '',
  },
  sentry: {
    enabled: false,
    dsn: '',
  },
  clarity: {
    projectId: '',
  },
  unleash: {
    enabled: false,
    url: '',
    clientKey: '',
    appName: 'onebeat-demo',
    refreshInterval: 30,
  },
  piniaStoreKeyPrefix: 'onebeat:',
};
